import { Component, Inject, OnDestroy, OnInit, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Freelancer } from '../models/freelancer';
import { Status } from '../models/user-profile';
import { FreelancerStore } from '../state/freelancer.store';
import { Observable } from 'rxjs/Observable';

enum PageType {None, Next, Prev}

@Component({
  selector: 'app-slider-cv',
  templateUrl: './slider-cv.component.html',
  styleUrls: ['./slider-cv.component.css']
})
export class SliderCvComponent implements OnInit, OnDestroy {

  // jobInvited: JobsOffer;

  freelancerList: any;
  currentIndex: number;
  maxIndex: number;
  userId: string;
  // job: JobsOffer;
  sub: any;
  type: PageType = PageType.None;
  loading: Observable<boolean>;
  size: Observable<number>;
  filters: any;

  constructor(public dialogRef: MatDialogRef<SliderCvComponent>,
              public freelancerStore: FreelancerStore,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.currentIndex = 0;
    this.size = this.freelancerStore.freelancers.map((freelancers: Freelancer[]) => freelancers.length);
  }

  ngOnInit() {
    this.sub = this.freelancerStore.freelancers.subscribe(jobs => {
      this.freelancerList = jobs;
      this.maxIndex = jobs.length;

      if (this.type === PageType.None) {
        this.currentIndex = this.data.selected;
      } else if (this.type === PageType.Next) {
        this.currentIndex = 0;
      } else if (this.type === PageType.Prev) {
        this.currentIndex = this.maxIndex - 1;
      }

      // if (this.data.jobInvited) {
      //   this.jobInvited = this.data.jobInvited;
      // }

      this.userId = this.freelancerList[this.currentIndex].user.id;
      // this.job = this.offerList[this.currentIndex].job;
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  nextCV() {
    this.currentIndex++;
    if (this.currentIndex >= this.maxIndex) {
      this.currentIndex = 0;
      this.type = PageType.Next;
      // this.freelancerStore.nextPage(this.data.requirement, this.jobInvited);
      this.freelancerStore.nextPage(this.data.requirement);
    } else {
      this.userId = this.freelancerList[this.currentIndex].user.id;
      // this.job = this.offerList[this.currentIndex].job;
    }
  }

  prevCV() {
    this.currentIndex--;
    if (this.currentIndex < 0) {
      this.currentIndex = 0;
      this.type = PageType.Prev;
      this.freelancerStore.prevPage(this.data.requirement);
    } else {
      this.userId = this.freelancerList[this.currentIndex].user.id;
      // this.job = this.offerList[this.currentIndex].job;
    }
  }

  onStatusChanged(event: Status) {
    this.freelancerList[this.currentIndex].status = event;
  }

  onFavoriteChanged(event: boolean) {
    this.freelancerList[this.currentIndex].favorite = event;
  }
}



// WEBPACK FOOTER //
// /Users/everis/code/Dj/front.staff/src/app/slider-cv/slider-cv.component.ts